var _circle, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#B3D234"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.848 5.912H16.264C18.104 5.912 19.552 6.352 20.608 7.232C21.68 8.096 22.216 9.392 22.216 11.12C22.216 12.752 21.72 14.048 20.728 15.008C19.736 15.952 18.384 16.424 16.672 16.424H11.848V23H8.848V5.912ZM11.848 8.408V14H16.024C18.2 14 19.288 13.064 19.288 11.192C19.288 9.336 18.112 8.408 15.76 8.408H11.848Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3230_55560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9975 18.5C18.6175 18.5 17.5 19.62 17.5 21C17.5 22.38 18.6175 23.5 19.9975 23.5C21.38 23.5 22.5 22.38 22.5 21C22.5 19.62 21.38 18.5 19.9975 18.5ZM20 23C18.895 23 18 22.105 18 21C18 19.895 18.895 19 20 19C21.105 19 22 19.895 22 21C22 22.105 21.105 23 20 23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 19.9375C20.125 19.8339 20.0411 19.75 19.9375 19.75C19.8339 19.75 19.75 19.8339 19.75 19.9375V21.25L20.9096 21.9457C20.9942 21.9965 21.104 21.9695 21.1553 21.8852C21.2074 21.7998 21.1797 21.6883 21.0936 21.6372L20.125 21.0625V19.9375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3230_55560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(17 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.049951f359587abc42000ddbca7ad420.svg";
export { ForwardRef as ReactComponent };